(function( ){


	//<!-- Global site tag (gtag.js) - Google Analytics -->
	var script_gtag = document.createElement( "script" ) ;
	script_gtag.async = true ;
	script_gtag.src = "https://www.googletagmanager.com/gtag/js?id=UA-52347338-37" ;
	document.body.appendChild( script_gtag ) ;

	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	gtag('js', new Date());
	gtag('config', 'UA-52347338-37');

	window.gtag = gtag ;


//------------------------------------------------------------------------------------------------------------------------------


	Tracking = function( )
	{
		var _this = this , i ;

		//

		// 共通でトラッキングする対象を取得
		Tracking.target = document.getElementsByClassName( "js-tracking" ) ;

		new GAEventTrack( ) ;
		new ScrollDepthTrack( ) ;

		//

		Tracking.ga = function( category , action , label , value )
		{
			var gtag = window.gtag || null ;
			if( gtag )
			{
				gtag('event', action , {
					event_category: category ,
					event_action: action ,
					event_label: label ,
					event_value: value?value:null } ) ;
			}
		}

		Tracking.all = function( category , action , label )
		{
			Tracking.ga( category , action , label ) ;
		}
	}


//------------------------------------------------------------------------------------------------------------------------------


	var GAEventTrack = function( )
	{
		var i ;
		var target = document.getElementsByClassName( "ga" ) ;

		var onClick = function( evt )
		{
			// data-ga="category,action,label"
			var eventValue = evt.currentTarget.getAttribute( "data-tracking" ) ;
			eventValue = eventValue.split( "," ) ;

			if( evt.currentTarget.getAttribute( "data-tracking-once" ) != undefined )
			{
				if( GAEventTrack.sentTrack.indexOf( eventValue[0] ) != -1 )		return ;
				else 															GAEventTrack.sentTrack.push( eventValue[0] ) ;
			}

			gtag('event', eventValue[1] , {
					event_category: eventValue[0] ,
					event_action: eventValue[1] ,
					event_label: eventValue[2] ,
					event_value: eventValue[3]?eventValue[3]:null } ) ;
		}

		for( i = 0 ; i < target.length ; i++ )
		{
			target[i].addEventListener( "click" , onClick ) ;
		}

		for( i = 0 ; i < Tracking.target.length ; i++ )
		{
			Tracking.target[i].addEventListener( "click" , onClick ) ;
		}
	}
	GAEventTrack.sentTrack = [ ] ;


//------------------------------------------------------------------------------------------------------------------------------


	var ScrollDepthTrack = function( )
	{

		var i ;

		var pathname = location.pathname ;
		if( /\/$/.test(pathname) )	pathname = pathname + "index.html" ;

		// スクロールトラッキングをとりすぎると、トラッキングの回数制限に引っかかるため、
		// 1/100の人だけサンプリングしてトラッキング
		if( Math.random() > 0.01 )	return ;

		// //	-	-	-	-	-	-	-	-	-	-	-	-	-	-

		// var target = document.getElementsByClassName( "js-scroll-depth" ) ;

		// var _onEnter = function( evt )
		// {
		// 	var data_split = evt.data.split(",") ;
		// 	if( data_split.length < 2 )	data_split.push( "all" ) ;

		// 	gtag('event', data_split[0] , {
		// 		event_category: 'scroll_section' ,
		// 		event_action: data_split[0] ,
		// 		event_label: data_split[1] ,
		// 		non_interaction: true
		// 	} ) ;

		// 	// console.log( 'スクロール計測 - セクション' , data_split ) ;
		// }

		// var _init = function( )
		// {
		// 	for( i = 0 ; i < target.length ; i++ )
		// 	{
		// 		var temp = target[i] ;
		// 		var temp_data = target[i].getAttribute("data-scroll-depth") ;
		// 		var trackLabel = temp_data ? temp_data :
		// 									target[i].tagName.toLowerCase() +
		// 									( target[i].id != "" ? "#" + target[i].id : "" ) +
		// 									( target[i].className.replace( /scroll\-depth/gi , "" ) != "" ? ( "." + target[i].className.replace( /\s/gi , "." ) ).replace( /\.scroll\-depth/gi , "" ) : "" ) ;

		// 		ScrollEnterEvent.add( temp , { func:_onEnter , data:trackLabel , marginScale:0.3 , timeout:0.1 } ) ;
		// 	}
		// }
		// setTimeout( _init , 100 ) ;

		// //	-	-	-	-	-	-	-	-	-	-	-	-	-	-

		var sentPercent = 0 ;
		var _onScroll = function( evt )
		{
			var nowPercent = Math.floor( ( window.pageYOffset / ( document.body.offsetHeight-window.innerHeight ) ) * 10 ) * 10 ;

			if( nowPercent == Infinity ) 	nowPercent = 0 ;

			if( nowPercent > ScrollDepthTrack.trackData.percent )
			{
				ScrollDepthTrack.trackData.percent = nowPercent ;

				while( sentPercent <= ScrollDepthTrack.trackData.percent )
				{
					gtag('event', pathname , {
						event_category: 'scroll_%' ,
						event_action: pathname ,
						event_label: sentPercent+"%" ,
						non_interaction: true
					} ) ;

					// console.log( "スクロール計測 - パーセント" , sentPercent+"%" ) ;

					sentPercent += 20 ;

					if( sentPercent > 100 )		break ;
				}

				if( sentPercent > 100 )		document.removeEventListener( "scroll" , _onScroll ) ;
			}
		}

		document.addEventListener( "scroll" , _onScroll ) ;

	}
	ScrollDepthTrack.trackData =
	{
		section:[] ,
		percent:-1
	}


//------------------------------------------------------------------------------------------------------------------------------


	// DOMの準備が完了したら、呼ぶ
	document.readyState === "complete"
		? setTimeout( function(){ new Tracking(); } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new Tracking(); } ) ;


//-------------------------------------------------------------------------------------------------------------------------------


} )( ) ;
